import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import { useAsync } from 'react-use';
import { FormControl, FormHelperText, Input, InputLabel } from '@material-ui/core';

export const UserInfoInput = ({ schema }: FieldExtensionComponentProps<string>) => {
  const identityApi = useApi(identityApiRef);

  const { value: email } = useAsync(async () => {
    const profile = await identityApi.getProfileInfo();

    return profile.email;
  }, [identityApi]);

  return (
    <FormControl>
      <InputLabel>{schema.title}</InputLabel>
      <Input
        type="text"
        value={email || ''}
        disabled={true}
      />
      <FormHelperText>{schema.description}</FormHelperText>
    </FormControl>
  );
};
